import _ from 'lodash'
import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    list: [],
    item: {},
    listView: {},
    filter: {
      word: '',
      list: []
    },
    order: [], // (legacy) 상품순서
    orders: {}, // (new) 상품순서, 다중카테고리가 적용된 순서설정
    category: [],
    manageProduct: [],
    setting: {
      promotion: [
        { id: 'best', default: true },
        { id: 'signature', default: true },
        { id: 'promotion', default: true },
        { id: 'event', default: true },
        { id: 'sale', default: true },
        { id: 'heritage', default: true }
      ]
    }
  },
  mutations: {
    updateList (state, data) {
      state.list = data
    },
    updateSetting (state, data) {
      state.setting = data
    },
    setOrder (state, data) {
      if (Array.isArray(data)) {
        state.order = data
      } else {
        state.orders = data
      }
    },
    setItemList (state, data) {
      state.item.items = data
    },
    updateCategory (state, data) {
      const uncategorized = data.find(x => x.data.id === '') || {
        text: ' ',
        data: {
          id: '',
          label: 'uncategorized',
          image: []
        }
      }
      state.category = data.filter(x => x.data.id !== '').concat(uncategorized)
    },
    listView (state, data) {
      state.listView = data
    },
    initFilter (state) {
      function getCategory (arr) {
        let result = []
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          result.push(item.data.id)
          if (item.children && item.children.length > 0) {
            for (let j = 0; j < item.children.length; j++) {
              const child = item.children[j]
              result.push(child.data.id)
              if (child.children && child.children.length > 0) {
                for (let j = 0; j < child.children.length; j++) {
                  const tail = child.children[j]
                  result.push(tail.data.id)
                }
              }
            }
          }
        }
        return result
      }
      state.filter.word = ''
      state.filter.list = getCategory(state.category)
    },
    setFilter: function (state, data) {
      Object.keys(data).forEach(function (x) {
        state.filter[x] = data[x]
      })
    }
  },
  actions: {
    setListData ({ state }, data) {
      state.list = data
    },
    async getProductSetting ({ state }, id) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: `product/setting.json`
        })
        state.setting = {
          ...state.setting,
          ...res.data.message
        }
        return state.setting
      } catch (ex) {
        console.log(ex)
        return false
      }
    },
    async setProductSetting ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: `product/setting.json`,
          data: JSON.stringify(data)
        })
        return res
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async getProductItem ({ state }, id) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: `product/item/${id}.json`
        })
        state.item = res.data.message
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async setProductItem ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: `product/item/${data.id}.json`,
          data: JSON.stringify(data)
        })
        return res
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async getProductList ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'product/list/list.json'
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setProductList ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: `product/list/list.json`,
          data: JSON.stringify(data)
        })
        return res
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    setProductListData ({ dispatch }) {
      dispatch('getProductList').then(res => {
        const data = res || []
        dispatch('setListData', data).then(() => {
          return true
        })
      }).catch((ex) => {
        // alert(ex)
        console.log(ex)
        return false
      })
    },
    async getManageProduct ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce/center`, {
          cmd: 'sc-manage-product',
          func: 'get-products',
          id: store.state.authentication.requestId
        })
        state.manageProduct = res.data.message || []
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    /**
     * 여기부터 center용 임시 개발 페이지를 위한 기능
     * 상품 관리
     */
    async addProduct ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce/center`, {
          cmd: 'sc-manage-product',
          func: 'add-product',
          id: store.state.authentication.requestId,
          pId: data.pid,
          qty: data.qty,
          pname: data.pname,
          inventory: data.inventory || false
        })
        state.manageProduct = res.data.message || []
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async updateProduct ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce/center`, {
          cmd: 'sc-manage-product',
          func: 'update-product',
          id: store.state.authentication.requestId,
          pId: data.pid,
          qty: data.qty,
          pname: data.pname,
          inventory: data.inventory || false
        })
        state.manageProduct = res.data.message || []
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async delProduct ({ state }, pid) {
      try {
        const res = await axios.post(`${API.BASE_URL}/service/commerce/center`, {
          cmd: 'sc-manage-product',
          func: 'delete-product',
          id: store.state.authentication.requestId,
          pId: pid
        })
        state.manageProduct = res.data.message || []
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return ex.response.data
      }
    }
  },
  getters: {
    list: state => state.list,
    getServiceList: state => state.item && state.item.items && state.item.items.filter(x => x.service),
    getFilter: state => state.filter,
    getOrder: state => Object.keys(state.orders).length === 0 ? state.order : state.orders,
    getCategory: state => {
      const categoryChildrenIds = function (arr) {
        let result = []
        const ids = function (arr) {
          arr.forEach(function (x) {
            if (x.children && x.children.length) {
              ids(x.children)
            }
            result.push(x.data.id)
          })
          return result
        }
        return ids(arr)
      }
      return state.category.map(x => {
        const childrenIds = x.children && x.children.length ? categoryChildrenIds(x.children) : []
        return {
          ...x,
          ...childrenIds && {
            childrenIds: childrenIds
          }
        }
      })
    },
    getManageProduct: state => state.manageProduct,
    gateAllCategoryIds: state => {
      const categoryChildrenIds = function (arr) {
        let result = []
        const ids = function (arr) {
          arr.forEach(function (x) {
            if (x.children && x.children.length) {
              ids(x.children)
            }
            return result.push(x.data.id)
          })
          return result
        }
        return ids(arr)
      }
      const allCategoryIds = function (arr) {
        const allIds = arr.map(x => {
          const childrenIds = x.children && x.children.length ? categoryChildrenIds(x.children) : []
          return [x.data.id, ...childrenIds]
        })
        return _.flatten(allIds).filter(x => x !== '')
      }
      const ids = allCategoryIds(state.category)
      return ids
    },
    getFlattenCategory: state => (checkLast = false) => { // checkLast: 하나의 children을 가지고 있는지?
      const category = state.category
      const getCategoriess = (category) => {
        if(!category.children || !category.children.length){
          return category
        }
        return [category, _.flatMapDeep(category.children, getCategoriess)]
      }
      const flatten = _.flatMapDeep(category, getCategoriess).map(x => {
        return {
          id: x.data.id,
          ...x.childrenIds && x.childrenIds.length && {
            childrenIds: x.childrenIds
          },
          ...x.children && x.children.length && {
            childrenId: x.children.map(c => c.data.id)
          }
        }
      })
      const getParentIds = (obj) => {
        const id = obj.id
        const items = flatten.filter(x => {
          const parent = x.childrenIds
            ? checkLast
              ? x.childrenIds.includes(id) && x.childrenIds.length === 1
              : x.childrenIds.includes(id)
            : x.childrenId && x.childrenId.includes(id)
          return parent
        })
        const ids = items && items.map(x => x.id)
        return ids && ids.length ? {parentIds: ids} : null
      }
      const categoryMaps = flatten.map(x => {
        return {
          ...x,
          ...getParentIds(x)
        }
      })
      return categoryMaps
    },
    getProductSetting: state => state.setting
  }
}
